<template>
  <div v-loading="loading" element-loading-background="transparent" class="h-full overflow-hidden">
    <el-scrollbar class="h-[calc(100%-62px)] overflow-x-hidden">
      <template v-if="isCrowd">
        <crowd-invoice-task-card v-if="!isCompany || fromInvoice" :info="info" :duty="duty" />
      </template>
      <template v-else>
        <match-invoice-task-card :duty="duty" />
      </template>

      <!-- 订单信息 -->
      <crowd-order-card v-if="isCrowd" :info="info" :term="term" />
      <match-order-card v-else :info="info" :term="term" />

      <!-- 子订单信息 -->
      <crowd-sub-orders v-if="isCrowd" :info="info" :term="term" @reload="fetchData" />
      <match-sub-orders v-else :info="info" :term="term" @reload="fetchData" />

      <div class="base-card-info">
        <div class="info-card-title">
          订单日志
        </div>

        <el-table class="normal-table" :border="true" :scrollbar-always-on="true" :data="logs" :max-height="300">
          <el-table-column align="center" type="index" label="序号" :min-width="80" />
          <el-table-column align="center" prop="operationContext" label="日志内容" show-overflow-tooltip :min-width="260" />
          <el-table-column align="center" prop="logTime" label="操作时间" :min-width="160" />
          <el-table-column align="center" prop="creator" label="操作人" :min-width="120" />
        </el-table>
      </div>
    </el-scrollbar>

    <el-button class="mt-4" @click="closeAndBack">
      <svg-icon icon="icon-park-outline:return" />返回
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { SvgIcon } from '@vue3/components';
import { querySettlementDetail, useTabsStore } from '@core/main';
import { computed, PropType, ref } from 'vue';
import MatchInvoiceTaskCard from './widgets/invoice-info/MatchTaskCard.vue';
import CrowdInvoiceTaskCard from './widgets/invoice-info/CrowdTaskCard.vue';
import CrowdOrderCard from './widgets/order-info/CrowdOrderCard.vue';
import MatchOrderCard from './widgets/order-info/MatchOrderCard.vue';
import CrowdSubOrders from './widgets/order-info/CrowdSubOrders.vue';
import MatchSubOrders from './widgets/order-info/MatchSubOrders.vue';
import { ISettlementOrderDetail, ISettlementOrderDuty } from '@core/main/types';

defineOptions({ name: 'InvoiceSettlementInfo' }); // 发票订单详情

const { closeAndBack } = useTabsStore();

const route = useRoute();

const props = defineProps({
  term: {
    type: String as PropType<'company' | 'agent' | 'saas' | 'server'>,
    required: true,
  },
  module: {
    type: String as PropType<'zhongbao' | 'cuohe'>,
    default: 'zhongbao',
  },
});

const loading = ref(false);
const info = ref({} as ISettlementOrderDetail);

const isCrowd = computed(() => props.module === 'zhongbao');
const isCompany = computed(() => props.term === 'company');
const fromInvoice = computed(() => route.query.fromInvoice === '1');

const duty = computed(() => info.value.duty || {} as ISettlementOrderDuty);
const logs = computed(() => info.value.orderLogs || []);

async function fetchData() {
  loading.value = true;

  try {
    info.value = await querySettlementDetail(Number(route.query.id), props.module);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

fetchData();
</script>
